import { render, staticRenderFns } from "./ProgrammeSave.vue?vue&type=template&id=1339f5bf&"
import script from "./ProgrammeSave.vue?vue&type=script&lang=js&"
export * from "./ProgrammeSave.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeSave.vue?vue&type=style&index=0&id=1339f5bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports